/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetVersionPolicy200ResponseAndroid } from './GetVersionPolicy200ResponseAndroid';
import {
    GetVersionPolicy200ResponseAndroidFromJSON,
    GetVersionPolicy200ResponseAndroidFromJSONTyped,
    GetVersionPolicy200ResponseAndroidToJSON,
    GetVersionPolicy200ResponseAndroidToJSONTyped,
} from './GetVersionPolicy200ResponseAndroid';
import type { GetVersionPolicy200ResponseIos } from './GetVersionPolicy200ResponseIos';
import {
    GetVersionPolicy200ResponseIosFromJSON,
    GetVersionPolicy200ResponseIosFromJSONTyped,
    GetVersionPolicy200ResponseIosToJSON,
    GetVersionPolicy200ResponseIosToJSONTyped,
} from './GetVersionPolicy200ResponseIos';
import type { GetVersionPolicy200ResponseApp } from './GetVersionPolicy200ResponseApp';
import {
    GetVersionPolicy200ResponseAppFromJSON,
    GetVersionPolicy200ResponseAppFromJSONTyped,
    GetVersionPolicy200ResponseAppToJSON,
    GetVersionPolicy200ResponseAppToJSONTyped,
} from './GetVersionPolicy200ResponseApp';

/**
 * 
 * @export
 * @interface GetVersionPolicy200Response
 */
export interface GetVersionPolicy200Response {
    /**
     * 
     * @type {GetVersionPolicy200ResponseAndroid}
     * @memberof GetVersionPolicy200Response
     */
    android: GetVersionPolicy200ResponseAndroid;
    /**
     * 
     * @type {GetVersionPolicy200ResponseIos}
     * @memberof GetVersionPolicy200Response
     */
    ios: GetVersionPolicy200ResponseIos;
    /**
     * 
     * @type {GetVersionPolicy200ResponseApp}
     * @memberof GetVersionPolicy200Response
     */
    app: GetVersionPolicy200ResponseApp;
}

/**
 * Check if a given object implements the GetVersionPolicy200Response interface.
 */
export function instanceOfGetVersionPolicy200Response(value: object): value is GetVersionPolicy200Response {
    if (!('android' in value) || value['android'] === undefined) return false;
    if (!('ios' in value) || value['ios'] === undefined) return false;
    if (!('app' in value) || value['app'] === undefined) return false;
    return true;
}

export function GetVersionPolicy200ResponseFromJSON(json: any): GetVersionPolicy200Response {
    return GetVersionPolicy200ResponseFromJSONTyped(json, false);
}

export function GetVersionPolicy200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetVersionPolicy200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'android': GetVersionPolicy200ResponseAndroidFromJSON(json['android']),
        'ios': GetVersionPolicy200ResponseIosFromJSON(json['ios']),
        'app': GetVersionPolicy200ResponseAppFromJSON(json['app']),
    };
}

export function GetVersionPolicy200ResponseToJSON(json: any): GetVersionPolicy200Response {
    return GetVersionPolicy200ResponseToJSONTyped(json, false);
}

export function GetVersionPolicy200ResponseToJSONTyped(value?: GetVersionPolicy200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'android': GetVersionPolicy200ResponseAndroidToJSON(value['android']),
        'ios': GetVersionPolicy200ResponseIosToJSON(value['ios']),
        'app': GetVersionPolicy200ResponseAppToJSON(value['app']),
    };
}

